import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { SigninSignupOptions } from '../../signin-signup-options.interface';
import { SigninSignupService } from '../../signin-signup.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../classes/user';
import { CustomValidators } from '../../validators/custom-validators';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SigninComponent implements OnInit {

  loginForm: FormGroup;
  user = new User();
  submitted: boolean = false;
  errorMessage: any = null;
  isLoggingIn: boolean = false;
  existingUser: boolean = false;
  fillEmailId: boolean = false;

  constructor(
    public signinSignupService: SigninSignupService,
    public formBuilder: FormBuilder,
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  @Input()
  set options(opt: SigninSignupOptions) {
    this.attachChanges(opt);
  }

  @Input() set featureObject(value) {
    this.signinSignupService.featureObject = value;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (this.activatedRoute.snapshot.queryParams['existingEmailId']) {
        this.existingUser = true;
        this.user.emailAddress = this.activatedRoute.snapshot.queryParams['existingEmailId'];
      }
      if(this.activatedRoute.snapshot.queryParams['fillEmailId']) {
        this.fillEmailId = true;
        this.user.emailAddress = this.activatedRoute.snapshot.queryParams['fillEmailId'];
      }
    });
    this.loginForm = this.formBuilder.group({
      emailAddress: [
        this.user.emailAddress,
        Validators.compose([Validators.required, CustomValidators.email])
      ],
      password: [this.user.password, Validators.compose([Validators.required])]
    });
    (<any>window).Events.publish('signinPopupOpen', true);
  }

  ngAfterViewInit() {


    setTimeout(() => {
      this.signinSignupService.focusFirstEmptyElement('login-email-input');
    }, 0);

    this.setEmailVerificationMsg();
  }

  // Attach all the changes received in the options object
  attachChanges(options): void {
    Object.keys(options).forEach(a => {
      if (this.signinSignupService.hasOwnProperty(a))
        this.signinSignupService[a] = options[a];
    });
  }

  closePopup(route?) {
    let w = (<any>window)
    this.submitted = false;
    this.errorMessage = null;

    setTimeout(() => {
      this.router.navigate([this.router.url], {
        queryParams: {
          existingEmailId: null
        }
      });
      w.Events.publish('updatePopupRoute', route ? route : null);
    }, 0);

    if (!route) {
      w.Events.publish('resetFeatureExecution');
    }

    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  closePopupKeydown(event) {
    this.signinSignupService.isTabKeyHit(event) ||
      (this.signinSignupService.isEnterKeyHit(event) && this.closePopup());
    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  routeToForgotPassword() {
    this.closePopup('forgot-password');
  }

  openSignUpPopup() {
    (<any>window).Events.publish('updatePopupRoute', 'sign-up');
  }

  openTermsPopup() {
    (<any>window).Events.publish('updatePopupRoute', {
      popup: 'log-in',
      innerPopup: 'terms-conditions'
    });
  }

  onSubmit() {
    let w = (<any>window);
    this.submitted = true;
    if (this.loginForm.valid) {
      this.signinSignupService.login(this.user, false).subscribe(
        result => {
          if (result) {
            this.submitted = false;
            w.Events.publish('SigninComplete', result);
            this.closePopup();
          }
        },
        error => {
          this.errorMessage = error && error.error ? error.error.message : null;
          w.Events.publish('detectChanges');
          if (error.status !== 400 && error.status !== 500) {
            w.Events.publish('SigninError', error);
            throw error;
          }
        }
      );
    }
    (<any>window).Events.publish('detectChanges'); //Angular 2 map-app specially
  }

  setEmailVerificationMsg() {
    if(this.activatedRoute.snapshot.queryParams['v'] && 
      (this.activatedRoute.snapshot.queryParams['redirectKey'] === 'maps' || this.activatedRoute.snapshot.queryParams['redirectKey'] === 'tourbooks')) {
      (<any>window).Events.publish('notificationInfo', 'Please Log In to verify your email');
    }
  }

  ngOnDestroy() {
    (<any>window).Events.publish('signinPopupOpen', false);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/signin-signup/components/signin/signin.component.ts